export function groupBy(arr, key) {
    return arr.reduce((groups, item) => {
        var _a;
        (groups[_a = key(item)] || (groups[_a] = [])).push(item);
        return groups;
    }, {});
}
//# sourceMappingURL=collection-utils.js.map